import Axios from 'axios';
import {CommonUtils} from "../ultilities";

const API_TIME_OUT = 5 * 60 * 1000;
export const API_BASE_URL = 'https://apidev.bmktech.vn';

const HttpClient = Axios.create({
	timeout: API_TIME_OUT
});

HttpClient.defaults.headers['Content-Type'] = 'application/json';

export const setUpHttpClient = (apiBaseUrl) => {
	let deviceId = localStorage.getItem('deviceId');
	let language = localStorage.getItem('language');
	if (!deviceId) {
		deviceId = CommonUtils.generateUUID();
		localStorage.setItem('deviceId', deviceId);
	}
	if (!language) {
		localStorage.setItem('language', 'vi');
	}
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(position => {
			localStorage.setItem('latitude', position.coords.latitude);
			localStorage.setItem('longitude', position.coords.longitude);
		});
	}
	HttpClient.defaults.baseURL = apiBaseUrl || API_BASE_URL;
	HttpClient.interceptors.request.use(config => {
		language = localStorage.getItem('language');
		config.headers.appVersion = 'v1';
		config.headers.latitude = localStorage.getItem('latitude');
		config.headers.longitude = localStorage.getItem('longitude');
		config.headers.deviceId = deviceId;
		config.headers['Accept-Language'] = language;
		config.requestUUID = CommonUtils.generateUUID();
		if (!config.headers.clientMessageId) {
			config.headers.clientMessageId = CommonUtils.generateUUID();
		}
		return config;
	});
	HttpClient.interceptors.response.use(response => {
		return response;
	}, e => {
		if (!e.response) {
			return e;
		}
		console.log(e)
		return e.response;
	});
};

export default HttpClient;


